<template>
    <div class="mt-8 w-full h-full bg-white">
      <PaymentMethods
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"/>
    </div>
  </template>

<script>
import PaymentMethods from '../components/PaymentMethod/PaymentMethods.vue';

export default {
  name: 'PaymentMethodView',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    PaymentMethods,
  },
  methods: {
    async fetchPaymentMethods() {
      try {
        await this.$store.dispatch('SettingsModule/PaymentMethods/fetchAllPaymentMethods');
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
  },
  mounted() {
    this.loading = true;
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.fetchPaymentMethods();
    this.loading = false;
  },
};
</script>

<style scoped></style>
